const PathConstants = {
  UNDER_MAINTENANCE: "/under-maintenance",

  HOME: "/",
  LOGIN: "/auth/login",
  SEARCH_PROPERTY: "/searchProperty",
  LEDGER: "/ledger",
  LEDGER_QUERY: "/ledger/:propertyId",
  LOGS: "/logs",

  DEBIT_CREDIT_NOTE: "/debit-credit-note",
  ARREARS_FORM: "/arrearsCorrection/:propertyId",

  OPERATORS_SEARCH: "/operators/search-property",
  OPERATORS_ARV_CALCULATIONS: "/operators/arv/:propertyId",

  ARV_CALCULATIONS: "/arv/:propertyId",

  PROPERTIES: "/properties",
  EDITED_PROPERTIES: "/properties/edited",
  PROPERTY_NOTICES: "/properties/notices",
  OLD_PROPERTIES: "/properties/old",
  ADD_PROPERTY: "/properties/add",
  EDIT_PROPERTY: "/properties/edit/:propertyId",
  PROPERTY_SPLIT: "/properties/split/:propertyId",
  GIS_MODULE: "/properties/gis",
  MUTATIONS: "/mutations",

  SELF_ASSESSMENT: "/self-assessment",
  SELF_ASSESSMENT_NIGAM: "/self-assessment/nigam",
  SELF_ASSESSMENT_STATUS: "/self-assessment/status",

  // PAY_ONLINE_TAX: "/onlinePayment",
  PAY_OFFLINE_TAX: "/offlinePayment",
  PAY_NEFT_TAX: "/neftPayment",
  PAYMENT: "/payment",
  PAYMENT_SUCCESS: "success/:txnId",
  PAYMENT_FAILURE: "failure/:txnId",
  TRANSACTIONS_POSTING_NIGAM: "payments/posting",
  PAYMENT_RECEIPT: "/paymentReceipt",
  TRANSACTIONS_OFFLINE: "/transactions/offline",
  TRANSACTIONS_POS: "/transactions/pos",
  TRANSACTIONS_NEFT: "/transactions/neft",
  ARCHIVED_TRANSACTIONS: "/transactions/archived",
  ALL_ONLINE_TRANSACTIONS: "/transactions/nigam/online",
  OLD_TRANSACTIONS: "/transactions/old",
  ADMIN_ONLINE_TRANSACTIONS: "/transactions/admin/online",
  PAYOUT_HISTORY: "/payout-history",
  WHATSAPP_PAYMENT: "/transactions/whatsapp",

  UPLOAD_OBJECTION: "/upload-objection",


  DEMAND_DASHBOARD: "/demand/dashboard",
  DEMAND_REPORTS: "/reports/demand",
  DEFAULTERS_LIST: "/reports/defaulters",
  ARV_LIST: "/reports/arv",
  COLLECTION_REPORT: "/reports/collection",
  REPORT_DASHBOARD: "/reports/dashboard",
  REPORT_GIS: "/reports/gis",
  COLLECTION_LIST_REPORT: "/reports/collection-list",

  DASHBOARD_REPORTS: "/dashboard/reports",
  DASHBOARD_OBJECTIONS: "/dashboard/objections",
  DASHBOARD_OBJECTIONS_OPERATOR: "/dashboard/operator/objections",
  OBJECTION_STATUS: "/objections/status",
  JALKAL_DASHBOARD: "/dashboard/jalkal",

  CONFIG_OPERATORS: "/masters/operators",
  CONFIG_WARDS: "/masters/ward",
  CONFIG_ZONES: "/masters/zone",
  CONFIG_MOHALLAS: "/masters/mohalla",
  CONFIG_OFFICIALS: "/masters/officials",
  CONFIG_DISCOUNTS: "/masters/discounts",
  CONFIG_ROLES: "/masters/roles",

  ADMIN_UTILITY: "/admin/utility",
  PUSH_DATA: "/admin/pushData",

  NOT_FOUND: "*",
};

export default PathConstants;
